import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import action from "./action";

export default combineReducers({
  auth,
  action,
  message,
});